import React from 'react';
import type { ReactNode } from 'react';
import { cssMap } from '@compiled/react';

import { Box } from '@atlaskit/primitives/compiled/box';
import { token } from '@atlaskit/tokens';

import { SectionCountBadge } from '../SectionCountBadge.tsx';

const styles = cssMap({
	header: {
		display: 'flex',
		alignItems: 'center',
		gap: token('space.100'),
	},
	label: {
		font: token('font.body'),
		fontWeight: token('font.weight.semibold'),
		color: token('color.text'),
	},
});

export type SectionHeaderProps = {
	icon: ReactNode;
	label: string;
	count: number;
};

/**
 * The heading above a `PressableGroup` — icon, label, and how many items the group holds.
 *
 * The count sits in its own badge rather than in the label text so it stays legible when the
 * label is translated. That badge is `SectionCountBadge`, shared with the collapsible sections
 * above this one, so both read as the same count rather than two near-misses.
 */
export const SectionHeader = ({ icon, label, count }: SectionHeaderProps): React.JSX.Element => (
	<Box xcss={styles.header}>
		{icon}
		<Box xcss={styles.label}>{label}</Box>
		<SectionCountBadge count={count} />
	</Box>
);
